export default __webpack_public_path__ + "static/media/11-72.a3dae9f1.png";